import React from "react";
import { Paper, Stack } from "@mui/material";
import styled from "styled-components";
import ShowWithSkeleton from "src/utils/show-with-skeleton";
import CustomTooltip from "src/components/custom-tooltip";
import DashboardTooltipTeams from "src/components/dashboard-tooltip-teams";
import DashboardTooltip from "src/components/dashboard-tooltip";

const MiniCenterCard = styled(Paper)`
    height: 8.25rem;
    border-radius: 0;
`;

const CardTitle = styled.h2`
    font-size: 14px;
    font-weight: 400;
`;

const Description = styled.p`
    font-size: 10px;
    font-weight: 300;
    padding-bottom: 6px;
    margin: 0;
`;

const MeetingsCancelledRescheduled = ({ fetchAction, teamApi }) => {
    const overallCancelled =
        fetchAction &&
        fetchAction.data &&
        fetchAction.data.meetingCancellations &&
        fetchAction.data.meetingCancellations.cancelled &&
        fetchAction.data.meetingCancellations.cancelled.reduce((acc, curr) => {
            // eslint-disable-next-line no-param-reassign
            acc += curr.count;
            return acc;
        }, 0);

    const overallRescheduled =
        fetchAction &&
        fetchAction.data &&
        fetchAction.data.meetingCancellations &&
        fetchAction.data.meetingCancellations.rescheduled &&
        fetchAction.data.meetingCancellations.rescheduled.reduce((acc, curr) => {
            // eslint-disable-next-line no-param-reassign
            acc += curr.count;
            return acc;
        }, 0);

    const getTooltipTitle = (text) => {
        return teamApi ? (
            <DashboardTooltipTeams integrationsNeeded="meetings" text={text} teamApi={teamApi} />
        ) : (
            <DashboardTooltip integrationsNeeded="meetings" text={text} />
        );
    };

    return (
        <>
            <MiniCenterCard>
                <Stack direction="column" ml={3} pt={0.5} style={{ height: "100%" }}>
                    <Stack direction="column" alignItems="left">
                        <Stack direction="row" justifyContent="space-between">
                            <CustomTooltip
                                title={getTooltipTitle(
                                    "Meetings that were cancelled less than 24 hours before they were meant to take place. These last minute changes may have impact on the schedule"
                                )}
                            >
                                <CardTitle>Meetings cancelled</CardTitle>
                            </CustomTooltip>
                            <p style={{ paddingRight: "16px" }}>
                                {overallCancelled !== 0 ? overallCancelled : "-"}
                            </p>
                        </Stack>
                    </Stack>
                    <ShowWithSkeleton
                        fetchAction={fetchAction}
                        height="100%"
                        width="95%"
                        streamingProperty={
                            fetchAction.data &&
                            fetchAction.data.meetingCancellations &&
                            fetchAction.data.meetingCancellations.cancelled
                        }
                    >
                        {fetchAction &&
                            fetchAction.data &&
                            fetchAction.data.meetingCancellations &&
                            fetchAction.data.meetingCancellations.cancelled && (
                                <Stack
                                    direction="column"
                                    style={{ overflow: "auto", height: "65%" }}
                                >
                                    {fetchAction.data.meetingCancellations.cancelled.map(
                                        ({ name, count }) => {
                                            return (
                                                <Stack
                                                    direction="row"
                                                    justifyContent="space-between"
                                                    pr={2.3}
                                                >
                                                    <Description>{name}</Description>
                                                    <Description>{count}</Description>
                                                </Stack>
                                            );
                                        }
                                    )}
                                </Stack>
                            )}
                    </ShowWithSkeleton>
                </Stack>
            </MiniCenterCard>
            <MiniCenterCard>
                <Stack direction="column" ml={3} pt={0.5} mt={1} style={{ height: "100%" }}>
                    <Stack direction="column" alignItems="left">
                        <Stack direction="row" justifyContent="space-between">
                            <CustomTooltip
                                title={getTooltipTitle(
                                    "Meetings that were rescheduled less than 24 hours before they were meant to take place. These last minute changes may have impact on the schedule"
                                )}
                            >
                                <CardTitle>Meetings rescheduled</CardTitle>
                            </CustomTooltip>
                            <p style={{ paddingRight: "16px" }}>
                                {overallRescheduled !== 0 ? overallRescheduled : "-"}
                            </p>
                        </Stack>
                    </Stack>
                    <ShowWithSkeleton
                        fetchAction={fetchAction}
                        height="100%"
                        width="95%"
                        streamingProperty={
                            fetchAction.data &&
                            fetchAction.data.meetingCancellations &&
                            fetchAction.data.meetingCancellations.rescheduled
                        }
                    >
                        {fetchAction &&
                            fetchAction.data &&
                            fetchAction.data.meetingCancellations &&
                            fetchAction.data.meetingCancellations.rescheduled && (
                                <Stack
                                    direction="column"
                                    style={{
                                        overflow: "auto",
                                        height: "65%",
                                    }}
                                >
                                    {fetchAction.data.meetingCancellations.rescheduled.map(
                                        ({ name, count }) => {
                                            return (
                                                <Stack
                                                    direction="row"
                                                    justifyContent="space-between"
                                                    pr={2.3}
                                                >
                                                    <Description>{name}</Description>
                                                    <Description>{count}</Description>
                                                </Stack>
                                            );
                                        }
                                    )}
                                </Stack>
                            )}
                    </ShowWithSkeleton>
                </Stack>
            </MiniCenterCard>
        </>
    );
};
export default MeetingsCancelledRescheduled;
